// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { useDispatch, useSelector } from "react-redux";

interface SelectVariantFromImages {
    variantId: string;
    productInfo: ProductInfo;
}

const useSetSelectedVariant = () => {
    const dispatch = useDispatch();
    const setSelectedVariant = (selectedVariant: SelectVariantFromImages) => {
        const { variantId, productInfo } = selectedVariant;
        dispatch({
            type: "Pages/ProductDetails/UpdateVariantSelection",
            variantSelection: variantId,
            variantSelectionCompleted: true,
            selectedProductInfo: productInfo,
        });
    };
    return setSelectedVariant;
};
export default useSetSelectedVariant;
